import {
  CardNumber,
  ExpiryDate,
  SecurityCode,
} from '@gr4vy/secure-fields-react'
import styled from 'styled-components'

import TextInput from '~/components/text-input'

export const StyledTextInput = styled(TextInput)`
  input {
    font-family: 'futura';
    height: 48px;
    padding: 16px;

    &::placeholder {
      color: ${({ theme }) => theme.color.border.input.default};
    }
  }
`

export const StyledCardNumber = styled(CardNumber)<{ $hasError: boolean }>`
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.color.border.danger : theme.color.border.input.default};
  height: 48px;
`

export const StyledExpiryDate = styled(ExpiryDate)<{ $hasError: boolean }>`
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.color.border.danger : theme.color.border.input.default};
  height: 48px;
`

export const StyledSecurityCode = styled(SecurityCode)<{ $hasError: boolean }>`
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.color.border.danger : theme.color.border.input.default};
  height: 48px;
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-bottom: 16px;
  max-width: 500px;

  .secure-fields__input[data-secure-fields-invalid] {
    border-color: ${({ theme }) => theme.color.border.danger};
  }
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

export const FieldRow = styled.div<{ $isOddWidth: boolean }>`
  display: flex;
  flex-direction: row;

  /*
   * The iframe element doesn't handle fractional pixel widths on iOS safari.
   * Here we ensure that we have a whole number width.
   */
  column-gap: ${({ $isOddWidth }) => ($isOddWidth ? '17px' : '16px')};
`
